import {
  useState,
  forwardRef,
  ForwardRefRenderFunction,
  InputHTMLAttributes,
} from "react";
import { ErrorMessage } from "../ErrorMessage";

import { Container, Content, Input, Label, ExtraInformation } from "./styles";

interface UnControlCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  labelFor?: string;
  label?: string;
  extraInformation?: string;
}

interface ControlCheckboxProps extends UnControlCheckboxProps {
  onCheck?: (status: boolean) => void;
  isChecked?: boolean;
}

const CheckboxBase: ForwardRefRenderFunction<
  HTMLInputElement,
  UnControlCheckboxProps
> = ({ error, labelFor, label, extraInformation, ...rest }, ref) => {
  return (
    <Container>
      <Content>
        <Input {...rest} type="checkbox" ref={ref} id={labelFor} />
        <Label htmlFor={labelFor}>{label}</Label>
      </Content>
      {extraInformation && (
        <ExtraInformation>{extraInformation}</ExtraInformation>
      )}
      {error && <ErrorMessage erro={error} />}
    </Container>
  );
};

export const UnControlCheckbox = forwardRef(CheckboxBase);

export const ControlCheckbox = ({
  error,
  labelFor,
  value,
  label,
  isChecked = false,
  onCheck,
  ...rest
}: Omit<ControlCheckboxProps, "extraInformation">) => {
  const [checked, setChecked] = useState(isChecked);

  const onChange = () => {
    const status = !checked;
    setChecked(status);

    !(onCheck == null) && onCheck(status);
  };

  return (
    <Container>
      <Content>
        <Input
          {...rest}
          checked={checked}
          onChange={onChange}
          value={value}
          type="checkbox"
          {...(labelFor ? { id: labelFor } : {})}
        />
        {!!labelFor && <Label htmlFor={labelFor}>{label}</Label>}
      </Content>
      {error && <ErrorMessage erro={error} />}
    </Container>
  );
};
